import React from 'react'
import { useTranslation } from 'react-i18next'
import { AppBar, Box, Toolbar, Typography } from '@mui/material'
import PropTypes from 'prop-types'

import { PUBLIC_URL } from '../../common/constants'

function TitleBar({ isRefactory }) {
  const { t } = useTranslation()

  return (
    <AppBar position="relative" elevation={0}>
      {isRefactory ? (
        <Toolbar sx={{ pl: { xs: 1 }, justifyContent: 'space-between' }}>
          <img
            src={`${PUBLIC_URL}/assets/favicons/refactory-icon.png`}
            height={40}
            alt=""
          />
          <Typography variant="h1">{t('pdf.refactoryTitle')}</Typography>
        </Toolbar>
      ) : (
        <Toolbar sx={{ py: 1, justifyContent: 'center' }}>
          <Box>
            <img
              src={`${PUBLIC_URL}/assets/favicons/apple-icon-60x60.png`}
              height={50}
              alt=""
            />
          </Box>
          <Typography variant="h1">{t('pdf.title')}</Typography>
        </Toolbar>
      )}
    </AppBar>
  )
}

TitleBar.propTypes = {
  isRefactory: PropTypes.bool,
}

export default TitleBar
